import React from 'react';

const ShowContext = React.createContext<any>(null);

export default ShowContext;
